module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator__psla-award"
  }, [_c('h2', [_vm._v(_vm._s(_vm.award.case_name))]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('tr', [_c('td', [_vm._v("Claimant Age at Trial/Deceased Age")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.age_display))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Updated PSLA Award (May 2017)")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.award.award)) + "\n                    ")]), _vm._v(" "), (_vm.showButtons) ? _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.award.award)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")]) : _vm._e()])]), _vm._v(" "), (_vm.afterDate) ? _c('tr', [_c('td', [_vm._v("Updated PSLA Award (" + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ")")]), _vm._v(" "), _c('td', {
    staticClass: "c-gd-psla-calculator__award-container u-position-relative"
  }, [_c('div', {
    staticClass: "c-gd-psla-calculator__award"
  }, [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")]), _vm._v(" "), (_vm.showButtons) ? _c('button', {
    staticClass: "a-button a-button--smaller u-float-r",
    on: {
      "click": function($event) {
        return _vm.usePslaAward(_vm.equivalent)
      }
    }
  }, [_vm._v("\n                        Use this PSLA Award\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration of Symptoms")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.duration) + " month" + _vm._s(_vm.award.duration === 1 ? '' : 's'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reduction in Life Expectancy")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.reduction_in_life))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Effects of Injury")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.award.effects))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1099985e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/general-damages/PslaAward.vue
// module id = 1572
// module chunks = 0